/** @format */

import { Layout } from "../components/common/Layout";
import dynamic from "next/dynamic";
import Spinner from "../components/Spinner/Spinner";

const AboutUsWrapper = dynamic(
  () => import("../components/AboutUs/AboutUsWrapper"),
  {
    ssr: false,
    loading: () => <Spinner />,
  }
);

export default function AboutUs() {
  const meta = {
    title: "Qalara | Trusted global sourcing & wholesale platform from India",
    description:
      "Global wholesale platform for sourcing artisanal & sustainable lifestyle goods - Décor, Rugs ,Carpets, Kitchen, Fashion, Kids, Toys, Cushions, Home linen, vases",
    keywords:
      "handmade, fair trade, wholesale buying, global sourcing, Indian crafts, Exporters from India, Verified manufacturers and suppliers, B2B platform",
    url: "/AboutUs/",
  };

  return (
    <Layout meta={meta}>
      <AboutUsWrapper />
    </Layout>
  );
}
